import {TaxSummary} from '@wix/auto_sdk_ecom_current-cart';

export class TaxSummaryModel {
  public taxName?: string;

  constructor(params: TaxSummaryModel) {
    this.taxName = params.taxName;
  }

  public static fromCartV1(taxSummary?: TaxSummary) {
    return new TaxSummaryModel({
      taxName: taxSummary?.taxName ?? '',
    });
  }
}
